import Box from "@mui/material/Box";
import LightTooltip from "controls/global/light-tooltip";
import React, { ReactNode, useRef, useState } from "react";
import { isEllipsisShown } from "utils/shared";
import { Typography, styled } from "@mui/material";
import { fontSize, margin, padding } from "theme/defaultStyle";

interface Props {
  title: string;
  duplicateAgencies: string[];
  children?: ReactNode;
  className?: string;
}

const StyledText = styled("div")({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

const StyledList = styled("ul")({
  margin: margin.zero,
  paddingLeft: padding.xlarge,
  fontSize: fontSize.small,
});

const StyledTypography = styled(Typography)({
  fontSize: fontSize.small,
});

const DuplicateSignaturesTooltip = ({
  title,
  duplicateAgencies,
  children,
  className,
}: Props) => {
  const [openTooltip, setOpenTooltip] = useState<boolean>(false);
  const inputElementRef = useRef<HTMLInputElement | null>(null);

  const handleOpenTooltip = (open: boolean) => {
    const show = open && isEllipsisShown(inputElementRef.current);
    setOpenTooltip(show);
  };

  const getTitleToRender = () => {
    if (duplicateAgencies.length > 0 && openTooltip) {
      return (
        <>
          <StyledTypography>Used by:</StyledTypography>
          <StyledList>
            {duplicateAgencies.map((agency, index) => (
              <li key={index}>{agency}</li>
            ))}
          </StyledList>
        </>
      );
    }

    return title;
  };

  if (!title) return null;
  return (
    <Box
      onMouseEnter={() => handleOpenTooltip(true)}
      onMouseLeave={() => handleOpenTooltip(false)}
      className={className}
    >
      <LightTooltip
        arrow
        placement="right"
        title={getTitleToRender()}
        open={openTooltip}
      >
        <StyledText ref={inputElementRef}>{children ?? title}</StyledText>
      </LightTooltip>
    </Box>
  );
};

export default DuplicateSignaturesTooltip;
